<div class="approval-rule-form">
  <div class="p-5">
    <div class="d-flex justify-content-between">
      <div class="align-self-center">
        <h3 class="mt-4 inline">Apply Filter</h3>
      </div>
      <div class="align-self-center">
        <button
          type="button"
          class="lum-button lum-button--secondary"
          mat-button
          (click)="dialogRef.close()"
        >
          <lum-ui-icon
            class="mr-2-5"
            icon="close-circle"
            color="#5563D6"
            width="23"
            height="23"
          ></lum-ui-icon>
          Close
        </button>
      </div>
    </div>
    <mat-divider class="my-2"></mat-divider>
  </div>
  <form [formGroup]="form">
    <div class="p-5">
      <div class="row">
        <div class="col-6">
          <div class="form-group">
            <label>Logical Operator</label>
            <mat-select class="lum-select" formControlName="operator">
              <mat-option
                *ngFor="
                  let logicalOperator of logicalOperators;
                  trackBy: trackByValue
                "
                [value]="logicalOperator.value"
              >
                {{ logicalOperator.label }}
              </mat-option>
            </mat-select>
            <mat-error *ngIf="form.get('operator')?.invalid">
              {{ form.get('operator') | validateField }}
            </mat-error>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div>
            <h5><strong>Conditions</strong></h5>
            <table class="lum-table lum-table--classic striped">
              <thead>
                <tr>
                  <th>&nbsp;</th>
                  <th class="w-p35">Field</th>
                  <th class="w-p15">Operator</th>
                  <th class="w-p35">Value</th>
                  <th>&nbsp;</th>
                </tr>
              </thead>
              <tbody
                id="approval-rule-conditions"
                cdkDropList
                (cdkDropListDropped)="drop($event)"
                formArrayName="condition"
              >
                <ng-container
                  *ngFor="
                    let item of conditionsFormArray?.controls;
                    trackBy: trackByControlValue;
                    let i = index
                  "
                >
                  <tr
                    cdkDrag
                    cdkDragLockAxis="y"
                    [formGroupName]="i"
                    id="row-approval-rule{{ i }}"
                    [lumTableAnimateRow]="item.value.sku"
                  >
                    <td>
                      <lum-ui-icon
                        cdkDragHandle
                        class="mr-2 cursor-grab"
                        icon="menu"
                        color="#36363A"
                      ></lum-ui-icon>
                    </td>
                    <td>
                      <input
                        class="lum-input"
                        type="text"
                        formControlName="field"
                      />
                    </td>
                    <td>
                      <mat-select formControlName="operator" class="lum-select">
                        <mat-option
                          *ngFor="
                            let comparisonOperator of comparisonOperators;
                            trackBy: trackByLabel
                          "
                          [value]="comparisonOperator.value"
                        >
                          {{ comparisonOperator.label }}
                        </mat-option>
                      </mat-select>
                    </td>
                    <td>
                      <input
                        class="lum-input"
                        type="text"
                        formControlName="value"
                      />
                    </td>
                    <td class="actions">
                      <button
                        type="button"
                        class="lum-button lum-button--link text-red-500"
                        (click)="onRemoveCondition(i)"
                      >
                        <lum-ui-icon
                          icon="minus-circle"
                          [width]="16"
                          [height]="16"
                          color="#3a47af"
                        ></lum-ui-icon>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </tbody>
            </table>
          </div>
          <div class="mt-4">
            <button
              type="button"
              class="lum-button lum-button--secondary btn-block"
              [matMenuTriggerFor]="menu"
            >
              Add Condition(s)
            </button>
            <mat-menu
              class="lum-mat-menu"
              #menu="matMenu"
              yPosition="above"
              xPosition="before"
            >
              <button mat-menu-item (click)="onAddMultipleConditions(1)">
                Add 1 Condition
              </button>
              <button mat-menu-item (click)="onAddMultipleConditions(5)">
                Add 5 Conditions
              </button>
            </mat-menu>
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-3">
        <lum-ui-button [loading]="submittingForm" (clickEvent)="onSubmit()">
          Save
          <lum-ui-icon class="ml-2-5" icon="content-save"></lum-ui-icon>
        </lum-ui-button>
      </div>
    </div>
  </form>
</div>
